import { Skill, SkillPart, SkillPartType } from '@app-types/skill.types';

type OrderedSkillPart = SkillPart & { skillPartIndex: number };

export const orderSkillParts = (skill: Skill) => {
  if (!skill?.children?.length) {
    return [];
  }
  const skillPartTypeMapping = {
    [SkillPartType.LESSON]: skill.Lessons || [],
    [SkillPartType.PRACTICE]: skill.Practices || [],
    [SkillPartType.POLL]: skill.Polls || [],
  };
  const orderedSkillParts = skill.children.reduce<OrderedSkillPart[]>((prev, child) => {
    const skillParts = skillPartTypeMapping[child.type];
    const skillPartIndex = skillParts.findIndex((skillPart) => skillPart.id === child.id);
    const skillPart = skillParts[skillPartIndex];
    prev.push({ ...skillPart, skillPartIndex });
    return prev;
  }, []);
  return orderedSkillParts;
};
